<div
  class="flex flex-col md:flex-row md:gap-y-2"
  [ngClass]="{ '!flex-col': slot?.widget?.data?.pdpReview }"
>
  <div
    class="bg-[#ffffff] rounded-[4px] md:mb-[20px] md:mt-[20px] mt-[10px] text-left w-full"
    [ngClass]="{ 'md:w-[30%] p-[5px]': !slot?.widget?.data?.pdpReview }"
  >
    @if (!slot?.widget?.data?.pdpReview) {
      <p
        class="text-[#162F4D] md:text-[15px] text-[14px] leading-[20px] md:leading-[20px] font-bold uppercase md:px-3"
      >
        Ratings and Reviews
      </p>
    }

    @if (slot?.widget?.data?.pdpReview) {
      <p
        class="md:hidden text-[#162F4D] md:text-[15px] text-[14px] leading-[20px] md:leading-[20px] font-bold md:px-3 pb-[10px]"
      >
        {{ slot?.widget?.data?.allReviewsTitle }}
      </p>
      <div class="hidden md:flex items-start justify-between mb-6 px-1 md:px-0">
        <h1
          class="text-2xl font-semibold text-gray-900 flex-1 leading-tight line-clamp-2"
        >
          {{ slot?.widget?.data?.reviewData?.productInfo?.title }}
        </h1>

        <!-- Desktop: Dropdown for sorting reviews -->
        <div class="relative group w-[140px]">
          <div
            class="cursor-pointer flex items-center justify-between bg-white border border-[#dfdfdf] border-solid px-[15px] py-[6px]"
          >
            <div class="flex items-center gap-1">
              <div
                class="text-[#5B5B5B] text-[14px] whitespace-nowrap truncate"
              >
                {{ data?.sorting?.label }}
              </div>
            </div>

            <img
              [alt]="data?.sorting?.icon?.alt"
              [src]="data?.sorting?.icon?.url"
              class="fill-current h-4 w-4 ml-[2px]"
            />
          </div>
          <ul
            class="bg-white shadow rounded transform scale-0 group-hover:scale-100 absolute w-full text-[14px] z-[2] overflow-auto max-h-[350px]"
          >
            @for (option of data?.sorting?.options; track option) {
              <li
                class="hover:text-[#F94D00] cursor-pointer"
                style="padding: 14px 18px"
                (click)="actionEvent({ actionData: option?.action })"
              >
                {{ option?.label }}
              </li>
            }
          </ul>
        </div>
      </div>
    }

    <div
      [ngClass]="{
        'flex flex-col md:flex-row gap-[5px] md:gap-8':
          slot?.widget?.data?.pdpReview,
      }"
    >
      <div
        class="rating-show-all-in items-stretch md:border-none border-gray-300 rounded-[4px] border-solid border-[1px]"
      >
        <div
          class="rating-show-all-left flex flex-col px-3 py-3 md:py-5 border-b md:border-b-0 border-r md:border-r-0 !pb-0"
          [ngClass]="{ 'md:w-auto pl-0': slot?.widget?.data?.pdpReview }"
        >
          <div
            class="text-[#000000] md:text-[35px] text-[35px] leading-[30px] md:leading-[30px] font-bold text-center md:text-left"
          >
            {{ slot?.widget?.data?.ratingData?.rating?.value?.average }}
          </div>
          <div
            class="icon flex items-center justify-center md:justify-start gap-[8px] md:gap-[10px] font-bold py-2"
          >
            @for (
              star of [].constructor(
                getFloorVal(
                  slot?.widget?.data?.ratingData?.rating?.value?.average
                )
              );
              track $index
            ) {
              <svg
                width="20"
                height="21"
                class="md:w-[17px] md:h-[18px]"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.19975 1.52019L5.38586 5.19796L1.32753 5.78963C0.599753 5.89519 0.308086 6.79241 0.835864 7.3063L3.77198 10.1674L3.07753 14.2091C2.95253 14.9396 3.72198 15.4869 4.36642 15.1452L7.99698 13.2369L11.6275 15.1452C12.272 15.4841 13.0414 14.9396 12.9164 14.2091L12.222 10.1674L15.1581 7.3063C15.6859 6.79241 15.3942 5.89519 14.6664 5.78963L10.6081 5.19796L8.7942 1.52019C8.4692 0.864632 7.52753 0.856298 7.19975 1.52019Z"
                  fill="#f94d00"
                />
              </svg>
            }
            @if (
              getFloorVal(
                slot?.widget?.data?.ratingData?.rating?.value?.average
              ) < slot?.widget?.data?.ratingData?.rating?.value?.average
            ) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="text-[#f94d00] w-7 h-auto md:w-6 fill-current"
                width="16"
                height="17"
                viewBox="0 -4 25 25"
              >
                <path
                  d="M5.354 5.119 7.538.792A.516.516 0 0 1 8 .5c.183 0 .366.097.465.292l2.184 4.327 4.898.696A.537.537 0 0 1 16 6.32a.548.548 0 0 1-.17.445l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256a.52.52 0 0 1-.146.05c-.342.06-.668-.254-.6-.642l.83-4.73L.173 6.765a.55.55 0 0 1-.172-.403.58.58 0 0 1 .085-.302.513.513 0 0 1 .37-.245l4.898-.696zM8 12.027a.5.5 0 0 1 .232.056l3.686 1.894-.694-3.957a.565.565 0 0 1 .162-.505l2.907-2.77-4.052-.576a.525.525 0 0 1-.393-.288L8.001 2.223 8 2.226v9.8z"
                ></path>
              </svg>
            }
          </div>
          <small
            class="text-[#5B5B5B] md:text-[14px] text-[13px] leading-[18px] mb-3 text-center"
            [ngClass]="{ 'md:text-left': !slot?.widget?.data?.pdpReview }"
            >{{ slot?.widget?.data?.ratingData?.rating?.value?.ratingCount }}
            Ratings,
            {{ slot?.widget?.data?.ratingData?.rating?.value?.reviewCount }}
            Reviews</small
          >
        </div>
      </div>
      <div
        class="rating-show-all-center grid grid-cols-1 col-span-2 md:col-span-1 pt-[15px] md:py-[25px] border-b md:border-b-0 w-full"
        [ngClass]="{ 'md:!w-auto': slot?.widget?.data?.pdpReview }"
      >
        <!-- Rating bars section -->
        <div class="flex w-full gap-[5px] items-start mb-4 md:mb-0">
          <!-- Stars column -->
          <ul
            class="flex flex-col gap-[15px] text-xs md:text-sm text-[#5B5B5B] text-end"
          >
            @for (star of [5, 4, 3, 2, 1]; track star) {
              <li class="flex items-center justify-end gap-[3px] h-[8px]">
                <span class="tabular-nums leading-none">{{ star }}</span>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="flex-shrink-0"
                >
                  <path
                    d="M7.19975 1.52019L5.38586 5.19796L1.32753 5.78963C0.599753 5.89519 0.308086 6.79241 0.835864 7.3063L3.77198 10.1674L3.07753 14.2091C2.95253 14.9396 3.72198 15.4869 4.36642 15.1452L7.99698 13.2369L11.6275 15.1452C12.272 15.4841 13.0414 14.9396 12.9164 14.2091L12.222 10.1674L15.1581 7.3063C15.6859 6.79241 15.3942 5.89519 14.6664 5.78963L10.6081 5.19796L8.7942 1.52019C8.4692 0.864632 7.52753 0.856298 7.19975 1.52019Z"
                    fill="#5B5B5B"
                  />
                </svg>
              </li>
            }
          </ul>

          <!-- Bars column -->
          <ul
            class="flex flex-col gap-[15px] w-full"
            [ngClass]="{ 'md:min-w-[250px]': slot?.widget?.data?.pdpReview }"
          >
            @for (
              ratingData of slot?.widget?.data?.ratingData?.rating?.value
                ?.histogram;
              track $index;
              let i = $index
            ) {
              <li class="flex items-center h-[8px]">
                <div class="h-[8px] bg-[#DFDFDF] rounded relative w-full">
                  <span
                    class="absolute inset-y-0 left-0 rounded"
                    [ngStyle]="histogramCSSStylesMap.get(i)"
                  ></span>
                </div>
              </li>
            }
          </ul>

          <!-- Count column -->
          <ul
            class="flex flex-col gap-[15px] text-xs md:text-sm text-[#5B5B5B]"
          >
            @for (
              ratingData of slot?.widget?.data?.ratingData?.rating?.value
                ?.histogram;
              track $index
            ) {
              <li class="flex items-center justify-start h-[8px]">
                <span class="tabular-nums leading-none">{{
                  ratingData?.percentage
                }}</span>
              </li>
            }
          </ul>
        </div>

        <!-- Write Review Button -->
        @if (isLoggedIn()) {
          <div class="flex items-center justify-center mt-[10px] md:mt-[18px]">
            <button
              class="bg-gray-100 hover:bg-gray-400 text-gray-800 font-semibold py-2 px-4 rounded inline-flex items-center text-sm md:text-base w-full md:w-auto justify-center !text-[14px]"
              (click)="initiateReview()"
            >
              Write a product review
            </button>
          </div>
        }
      </div>
    </div>
  </div>

  <div
    class="w-full bg-white"
    [ngClass]="{ 'md:w-[70%] p-[10px]': !slot?.widget?.data?.pdpReview }"
  >
    @if (isLoggedIn() && slot?.widget?.data?.reviewData?.showWriteReview) {
      <div class="flex items-center justify-end m-2">
        <button
          class="bg-gray-100 hover:bg-gray-400 text-gray-800 font-semibold py-2 px-4 rounded inline-flex items-center text-sm md:text-base w-full md:w-auto justify-center !text-[14px]"
          (click)="initiateReview()"
        >
          Write a product review
        </button>
      </div>
    }
    <div
      class="md:flex md:gap-8 bg-white"
      [ngClass]="{ 'md:ml-[40px]': !slot?.widget?.data?.pdpReview }"
    >
      <div class="flex-1 min-w-0">
        @if (!StringUtils.isEmpty(userGalleryImages)) {
          <div class="md:hidden mt-5">
            <div
              class="flex gap-2 overflow-x-auto pb-2 no-scrollbar cursor-pointer"
            >
              @for (
                image of userGalleryImages.slice(0, 7);
                track image?.value?.id;
                let i = $index
              ) {
                <div
                  class="w-24 h-24 flex-shrink-0 rounded border border-gray-200 bg-gray-100 relative"
                  (click)="launchMultimediaPopup(i)"
                >
                  <img
                    [src]="image?.value?.url"
                    class="w-full h-full object-cover rounded-md"
                  />
                  <span
                    class="w-[100%] h-[100%] absolute top-0 left-0 bg-black/40 rounded-md"
                  ></span>
                </div>
              }

              @if (userGalleryImages?.length > 7) {
                <div
                  class="w-24 h-24 flex-shrink-0 rounded border border-gray-200 bg-gray-100 relative"
                  (click)="launchMultimediaPopup(0, true)"
                >
                  <img
                    [src]="userGalleryImages[7]?.value?.url"
                    class="w-full h-full object-cover rounded-md"
                  />
                  <div
                    class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 text-white text-sm font-semibold rounded-md"
                  >
                    +{{ userGalleryImages?.length - 7 }}
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- Sorting pills (mobile view only) -->
        @if (!StringUtils.isEmpty(data?.sorting?.options)) {
          <div class="md:hidden border-b border-gray-200 pt-[35px] py-4">
            <div class="text-sm font-semibold text-gray-900 mb-3">
              {{ slot?.widget?.data?.userReviewsSortedBy }}
            </div>
            <div class="flex gap-2 overflow-x-auto no-scrollbar">
              @for (option of data?.sorting?.options; track option?.id) {
                <button
                  type="button"
                  class="px-3 py-1.5 text-xs font-medium rounded-full border transition-all flex-shrink-0 whitespace-nowrap focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#f94d00] md:px-4 md:py-2 md:text-sm md:font-semibold"
                  [ngClass]="
                    option?.id === data?.sorting?.selected
                      ? 'bg-[#f94d00] text-white border-[#f94d00]'
                      : 'bg-white text-gray-700 border-gray-300 hover:border-[#f94d00] hover:text-[#f94d00]'
                  "
                  (click)="onActionCall(option?.action)"
                  [attr.aria-pressed]="option?.id === data?.sorting?.selected"
                >
                  {{ option?.label }}
                </button>
              }
            </div>
          </div>
        }
        <div class="divide-y divide-gray-100">
          @for (
            review of visibleReviews;
            track review?.value?.id || $index;
            let i = $index
          ) {
            <div class="pt-6 md:pt-7 pb-[5px]">
              <div class="hidden md:flex items-center gap-3 mb-3">
                <div
                  class="flex items-center text-white text-sm font-semibold px-2.5 py-0.5 rounded-full tracking-wide"
                  [style.background-color]="review?.value?.badgeColor"
                >
                  {{ review?.value?.rating }} ★
                </div>
                <h3
                  class="text-sm font-[500] text-gray-900 flex-1 leading-snug"
                >
                  {{ review?.value?.title }}
                </h3>
              </div>

              <!-- mobile -->
              <div
                class="flex flex-wrap md:hidden items-center gap-1 mb-2 -ml-[6px]"
              >
                <div
                  class="flex text-sm w-fit float-left ml-[3px]"
                  style="transform: scale(0.9)"
                >
                  @for (
                    star of [].constructor(getFloorVal(review?.value?.rating));
                    track $index
                  ) {
                    <svg
                      width="20"
                      height="21"
                      class="md:w-[17px] md:h-[18px]"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.19975 1.52019L5.38586 5.19796L1.32753 5.78963C0.599753 5.89519 0.308086 6.79241 0.835864 7.3063L3.77198 10.1674L3.07753 14.2091C2.95253 14.9396 3.72198 15.4869 4.36642 15.1452L7.99698 13.2369L11.6275 15.1452C12.272 15.4841 13.0414 14.9396 12.9164 14.2091L12.222 10.1674L15.1581 7.3063C15.6859 6.79241 15.3942 5.89519 14.6664 5.78963L10.6081 5.19796L8.7942 1.52019C8.4692 0.864632 7.52753 0.856298 7.19975 1.52019Z"
                        fill="#f94d00"
                      />
                    </svg>
                  }
                  @if (
                    getFloorVal(review?.value?.rating) < review?.value?.rating
                  ) {
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="text-[#f94d00] w-7 h-auto md:w-6 fill-current"
                      width="16"
                      height="17"
                      viewBox="0 -4 25 25"
                    >
                      <path
                        d="M5.354 5.119 7.538.792A.516.516 0 0 1 8 .5c.183 0 .366.097.465.292l2.184 4.327 4.898.696A.537.537 0 0 1 16 6.32a.548.548 0 0 1-.17.445l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256a.52.52 0 0 1-.146.05c-.342.06-.668-.254-.6-.642l.83-4.73L.173 6.765a.55.55 0 0 1-.172-.403.58.58 0 0 1 .085-.302.513.513 0 0 1 .37-.245l4.898-.696zM8 12.027a.5.5 0 0 1 .232.056l3.686 1.894-.694-3.957a.565.565 0 0 1 .162-.505l2.907-2.77-4.052-.576a.525.525 0 0 1-.393-.288L8.001 2.223 8 2.226v9.8z"
                      ></path>
                    </svg>
                  }
                </div>

                <h3
                  class="text-sm font-semibold text-gray-900 leading-tight w-fit float-left"
                >
                  <span class="text-[#f94d00]">
                    {{ review?.value?.rating }}
                  </span>
                </h3>

                <p
                  class="text-sm font-[500] text-gray-900 leading-snug float-left ml-[7px]"
                >
                  • {{ review?.value?.title }}
                </p>
              </div>

              <!-- mobile -->
              @if (slot?.widget?.data?.pdpReview) {
                <div class="md:hidden text-sm text-gray-500">
                  <span class="line-clamp-2">
                    {{ review?.value?.reviewForText }}:
                    {{ data?.reviewData?.productInfo?.title }}
                  </span>
                </div>
              }

              <span class="text-sm text-gray-500 tracking-wide">
                {{ review?.value?.reviewedText }}:
                {{ review?.value?.createdRelativeTime }}
              </span>

              <div class="min-w-0 w-full">
                <p
                  class="text-sm text-gray-700 leading-relaxed break-all whitespace-normal"
                  (click)="
                    isReviewExpanded(getReviewKey(review, i)) &&
                      toggleReviewText(getReviewKey(review, i), $event)
                  "
                >
                  {{
                    getReviewText(review?.value?.text, getReviewKey(review, i))
                  }}
                </p>
                @if (
                  shouldShowReviewToggle(review?.value?.text) &&
                  !isReviewExpanded(getReviewKey(review, i))
                ) {
                  <button
                    class="text-[#f94d00] font-semibold text-[12px]"
                    type="button"
                    (click)="toggleReviewText(getReviewKey(review, i), $event)"
                    [attr.aria-expanded]="
                      isReviewExpanded(getReviewKey(review, i))
                    "
                  >
                    {{ slot?.widget?.data?.readMoreText }}
                  </button>
                }
              </div>

              @if (!StringUtils.isEmpty(getReviewMedia(review))) {
                <div class="flex flex-wrap gap-2">
                  @for (
                    image of getReviewMedia(review);
                    track image;
                    let i = $index
                  ) {
                    <div
                      class="flex gap-2 mt-[5px] overflow-x-auto py-1"
                      (click)="
                        launchMultimediaPopup(
                          i,
                          false,
                          review?.value?.multimedia?.data?.slot
                        )
                      "
                    >
                      <div
                        class="w-14 h-14 md:w-16 md:h-16 border bg-gray-100 rounded-md relative shrink-0 cursor-pointer overflow-hidden will-change-transform"
                      >
                        <img
                          class="w-full h-full object-cover rounded-md"
                          [src]="image?.value?.url"
                        />
                        <span
                          class="absolute inset-0 bg-black/40 rounded-md pointer-events-none"
                        ></span>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <div class="py-4 flex justify-center gap-2">
      @if (
        !slot?.widget?.data?.pdpReview &&
        allReviews?.length > 5 &&
        !showAllReviews()
      ) {
        <button
          class="bg-[#162F4D] text-white font-semibold py-1.5 px-4 rounded-full text-xs md:text-sm md:py-2 md:px-6 hover:bg-[#0f2237] transition-colors duration-200"
          type="button"
          (click)="showAll()"
        >
          {{ slot?.widget?.data?.readMoreText }}
        </button>
      }
      @if (slot?.widget?.data?.ratingData?.rating?.value?.viewAllReviewButton) {
        <button
          class="bg-[#162F4D] text-white font-semibold py-1.5 px-4 rounded-full text-xs md:text-sm md:py-2 md:px-6 hover:bg-[#0f2237] transition-colors duration-200"
          (click)="
            onActionCall(
              slot?.widget?.data?.ratingData?.rating?.value?.viewAllReviewButton
                ?.action
            )
          "
        >
          {{
            slot?.widget?.data?.ratingData?.rating?.value?.viewAllReviewButton
              ?.text
          }}
        </button>
      }
    </div>
  </div>
</div>
